import { useState } from "react";
import { signInWithEmailAndPassword, getAuth, signOut } from "firebase/auth";
import { ref, get } from "firebase/database";
import { firebaseApp, db } from "../firebaseConfig";
import "./style/Login.css";

const Login = ({ onLogin }) => {
    const auth = getAuth(firebaseApp);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");

        try {
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            if (!user) {
                setError("Authentication failed");
                return;
            }

            const userId = user.uid;

            const userRef = ref(db, `neoslide/users/${userId}`);
            const snapshot = await get(userRef);

            if (snapshot.exists()) {
                const userData = snapshot.val();

                if (userData.role === "superadmin") {
                    onLogin();
                } else {
                    await signOut(auth);
                    setError("Access denied: Only superadmins can log in.");
                }
            } else {
                await signOut(auth);
                setError("Access denied: User not authorized.");
            }
        } catch (err) {
            console.error("Login Error:", err);
            setError("Invalid email or password.");
        }
    };

    return (
        <div className="login-container">
            <form onSubmit={handleLogin}>
                <div>
                    <img src="/neoslide-logo.png" alt="NeoSlide Logo" width={100} />
                    <img src="/neoslide-logo-2.png" alt="NeoSlide Logo" width={150} />
                </div>
                <h2 className="login-container__title">NeoSlide Admin</h2>
                <input
                    className="login-container__input"
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <input
                    className="login-container__input"
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <button className="login__button" type="submit">Login</button>
                {error && <p className="error">{error}</p>}
            </form>
            <div className="copyright">
                Copyright © 2025 blackboxsolutions.mk
            </div>
        </div>
    );
};

export default Login;
